export {SettingsScreen as default} from "@features/swing-trading/screens";
